import React, { forwardRef, Ref } from 'react';
interface Props extends React.SVGProps<SVGSVGElement> {
  bell?: string;
  tick?: string;
}
const NotifyMeIcon = forwardRef<SVGSVGElement, Props>(({
  bell = '#5A6066',
  tick = '#5A6066',
  ...props
}, ref: Ref<SVGSVGElement>) => {
  return <svg viewBox="0 0 64 64" fill="none" ref={ref} {...props}>
        <path d="M49.778 23.111c0 19.556 8.889 17.778 8.889 26.667 0 0 0 3.556-3.556 3.556H8.889c-3.556 0-3.556-3.556-3.556-3.556 0-8.889 8.89-7.111 8.89-26.667 0-9.817 7.958-17.777 17.777-17.777s17.778 7.96 17.778 17.777" fill={bell} />
        <path stroke="white" d="M52 .5a12 12 0 1 0 0 24 12 12 0 0 0 0-24m6.811 9.884-7.2 6.6a1.2 1.2 0 0 1-1.66-.036l-3.6-3.6a1.2 1.2 0 1 1 1.697-1.696l2.788 2.787 6.353-5.823a1.2 1.2 0 0 1 1.622 1.768" fill={tick} />
        <path d="M32 10.667A5.333 5.333 0 1 0 32 0a5.333 5.333 0 0 0 0 10.667M32 64a7.11 7.11 0 0 0 7.111-7.111H24.89a7.11 7.11 0 0 0 7.11 7.11" fill={bell} />
      </svg>;
});
export default NotifyMeIcon;